import React from 'react';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { CoachingReservation } from 'coaching/containers/GetAvailableReservationsContainer';
import CoachingSelfServeReservationDetails from 'coaching/components/CoachingSelfServeView/CoachingSelfServeReservationDetails';
import Copy from 'components/Copy';
import Display from 'components/Display';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

import Stars from 'assets/images/coaching/stars_doodle.svg';

export type Props = {
  reservation?: CoachingReservation;
  userTimezone: string;
  childName?: string;
  userEmail?: string;
  childEmail?: string;
  participantUUID?: string;
};

export default function CoachingSelfServeSuccessView(props: Props) {
  React.useEffect(() => {
    EventTracking.trackKey('coaching.self_schedule_purchase.success.view');
  }, []);

  const { reservation, userTimezone, childName, userEmail, childEmail } = props;
  const childEmailConfirmationText = childEmail ? (
    <>
      an invitation to <Text weight="semibold">{childEmail}</Text>
    </>
  ) : (
    ''
  );
  const userEmailConfirmationText = userEmail ? (
    <>
      a confirmation to <Text weight="semibold">{userEmail ?? 'your email'}</Text>
    </>
  ) : (
    ''
  );
  const emailConfirmationText =
    userEmail || childEmail ? (
      <Row size="xsmall">
        <Text size="small">
          We’ve sent {childEmailConfirmationText}
          {Boolean(childEmailConfirmationText && userEmailConfirmationText) ? 'and ' : ''}
          {userEmailConfirmationText}.
        </Text>
      </Row>
    ) : null;

  return (
    <React.Fragment>
      <MediaObject figure="right">
        <div>
          <CoachingHeading>Your session is confirmed!</CoachingHeading>
          {reservation && childName && (
            <CoachingSelfServeReservationDetails
              reservation={reservation}
              childName={childName}
              userTimezone={userTimezone}
            />
          )}
        </div>
        <Display hide="480">
          <Image src={Stars} width={75} />
        </Display>
      </MediaObject>
      <Divider size="medium" />
      {emailConfirmationText}
      <Copy size="small" color="thunder">
        You’ll receive messages with instructions to get ready for your session. If you continue
        with Remind Coaching, you can choose to have your child receive messages too.
      </Copy>
      <Display hide="480">
        <div className="CoachingSelfServeSuccessView-footer" />
      </Display>
    </React.Fragment>
  );
}
